export default __webpack_public_path__ + "static/FrontPageBanner-c98f0cfe234dd058468d25bdcee31a1b.png";